<app-traitement-data titre="Déamb" [sousTitre]="patient!.tableauDeBord?.deambulation?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.deambulation?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.deambulation?.value ?? 'Pas de donnée' }}
</app-traitement-data>